
import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import { css } from "styled-components";

signInResetPasswordFormStyles.buttonsGridItem = {
	css: css`
		max-width: unset;
        flex-basis: unset;
        button{
            &:first-child{
                margin-right: 15px;
            }
        }
		${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                theme,
                [
                    css`
                        justify-content: flex-start;
                    `,
                    null,
                    null,
                    null,
                    null
                ],
                "max",
            )}
    `,
}

signInResetPasswordFormStyles.cancelButton = {
    color: "secondary",
	css: css`
		&:hover{
			background: ${WhitecapColors.gray3};
			color: ${WhitecapColors.white};
			opacity: 0.7;
			border-color:  ${WhitecapColors.gray3};
		}
    `,
}